import Rahul from "../../src/assets/images/Employees/rahul.webp"
import Saru from "../../src/assets/images/Employees/saru.webp"
import Jithin from "../../src/assets/images/Employees/jithin.webp"
import Aleena from "../../src/assets/images/Employees/aleena.webp"
import Person from "../../src/assets/images/Employees/person.png"
import Saneesh from "../../src/assets/images/Employees/saneesh.webp"
import Sunil from "../../src/assets/images/Employees/sunil.webp"
import Anu from "../../src/assets/images/Employees/anu.webp"
import Navya from "../../src/assets/images/Employees/navya.webp"
import Ritta from "../../src/assets/images/Employees/ritta.webp"
import Fransa from "../../src/assets/images/Employees/fransa.webp"
import Hr from "../../src/assets/images/Employees/hr.webp"
import Rahil from "../../src/assets/images/Employees/rahil.webp"
import Mariya from "../../src/assets/images/Employees/mariya.webp"
import Niya from "../../src/assets/images/Employees/niya.webp"
import Miju from "../../src/assets/images/Employees/miju.webp"
import Sajil from "../../src/assets/images/Employees/sajil.webp"
import Manju from "../../src/assets/images/Employees/manju.webp"
import Sumith from "../../src/assets/images/Employees/sumith.webp"
import Mohandas from "../../src/assets/images/Employees/mohandas.webp"
import Sheeba from "../../src/assets/images/Employees/sheeba.webp"

const Employees = {
    "Person": Person,
    "Rahul": Rahul,
    "Saru": Saru,
    "Jithin": Jithin,
    "Aleena": Aleena,
    "Nisha": Person,
    "Saneesh": Saneesh,
    "Sunil": Sunil,
    "Anu": Anu,
    "Navya": Navya,
    "Ritta": Ritta,
    "Fransa": Fransa,
    "Hr": Hr,
    "Rahil": Rahil,
    "Mariya": Mariya,
    "Niya": Niya,
    "Miju": Miju,
    "Sajil": Sajil,
    "Manju": Manju,
    "Sumith": Sumith,
    "Mohandas": Mohandas,
    'Sheeba': Sheeba
}

export default Employees;